module.exports = {
  agent: undefined, // https://nodejs.org/api/https.html#https_class_https_agent
  headers: {},
  requestMedia: 'application/vnd.github.v3+json',
  timeout: 0,
  baseUrl: 'https://api.github.com'
}
